// extracted by mini-css-extract-plugin
module.exports = {"headerWraper":"header_headerWraper__S-379","logo":"header_logo__13VgX"};